import React from 'react';

import {NucleotideType} from 'biojs/BioConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

/**
 * A dropdown selector for specifying a nucleotide type.
 *
 * @deprecated New UIs should rely on NucleotideTypeToggle.
 */
export default function NucleotideTypeSelector({
  nucleotideType,
  setNucleotideType,
}: {
  nucleotideType: NucleotideType;
  setNucleotideType: (nucleotideType: NucleotideType) => void;
}): JSX.Element {
  return (
    <SelectDropdown
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL} value={nucleotideType}>
          {[NucleotideType.DNA, NucleotideType.RNA].map((nucleotideTypeOption) => (
            <Option key={nucleotideTypeOption} value={nucleotideTypeOption} onSelect={setNucleotideType}>
              with a nucleotide type of {nucleotideTypeOption}
            </Option>
          ))}
        </Menu>
      }
      displayName={<span>with a nucleotide type of {nucleotideType}</span>}
    />
  );
}
